import * as React from 'react';
import {ReactNode} from 'react';

import {HintText} from './styled';

interface Props {
    text?: string | null | ReactNode;
    children: ReactNode;
    isError?: boolean;
    className?: string;
}

export function Hint({children, isError = true, text, className}: Props) {
    return (
        <div className={className}>
            {children}
            {text && <HintText isError={isError}>{text}</HintText>}
        </div>
    );
}
